import React from "react";
import { Route, Switch } from "react-router-dom";
import EvaluationList from "../SupplierSelection/TechnicalEvaluation/Screens/EvaluationList/EvaluationList";
import OfferList from "../SupplierSelection/OfferReceived/Screens/OfferList/OfferList";
import OfferSubmission from "../SupplierSelection/OfferReceived/Screens/OfferSubmission/OfferSubmission";
import RequestFeedbackForm from "../SupplierFeedback/Screens/RequestFeedback/RequestFeedbackForm";
import SubmitFeedbackForm from "../SupplierFeedback/Screens/SubmitFeedback/SubmitFeedbackForm";
import ViewFeedback from "../SupplierFeedback/Screens/ViewFeedback/ViewFeedback";
import AllFeedback from "../SupplierFeedback/Screens/AllFeedback/AllFeedback";
import FeedbackReport from "../SupplierFeedback/Screens/FeedbackReport/FeedbackReport";
import NewPackage from "../MaterialTracking/Screens/NewPackage/NewPackage";
import AllMaterial from "../MaterialTracking/Screens/AllMaterial/AllMaterial";
import ViewPackage from "../MaterialTracking/Screens/ViewPackage/ViewPackage";
import TrackPackage from "../MaterialTracking/Screens/TrackPackage/TrackPackage";
import NewClaim from "../Claims/Screens/NewClaim/NewClaim"
import AllClaim from "../Claims/Screens/AllClaims/AllClaims"
import ViewClaim from "../Claims/Screens/ViewClaims/ViewClaim";
import ProgressReport from "../DailyProgressReport/ProgressReport/ProgressReport";
import NewDPR from "../DailyProgressReport/NewDPR/NewDPR";

/**
 * Custom component mapping
 * @param {component} : Component being mapped
 * @param {routers} : Creating route for a component specified with route link
 */

export const path = process.env.REACT_APP_PROJECT_ROUTE=='/null'?"":process.env.REACT_APP_PROJECT_ROUTE

function getRoutes() {
  return {
    offer_received: {
      routers: [
        <Switch>
          <Route exact path={path + '/offer_received'} component={OfferList} />
          <Route exact path={path + '/offer_received/new'} component={OfferSubmission} />
        </Switch>
      ],
    },
    technical_evaluation: {
      routers: [
        <Switch>
          <Route exact path={path + '/technical_evaluation'} component={EvaluationList} />
        </Switch>
      ],
    },
    NewPackage: {
      routers: [
        <Switch>
          <Route exact path={path + '/NewPackage'} component={NewPackage} />
        </Switch>
      ],
    },
    AllPackages: {
      routers: [
        <Switch>
          <Route exact path={path + '/AllPackages'} component={AllMaterial} />
          <Route exact path={path + '/ViewPackage/:id'} component={ViewPackage} />
        </Switch>
      ],
    },
    TrackPackage: {
      routers: [
        <Switch>
          <Route exact path={path + '/TrackPackage'} component={TrackPackage} />
        </Switch>
      ],
    },
    RequestFeedback: {
      routers: [
        <Switch>
          <Route exact path={path + '/RequestFeedback'} component={RequestFeedbackForm} />
        </Switch>
      ],
    },
    AllFeedback: {
      routers: [
        <Switch>
          <Route exact path={path + '/SubmitFeedback/:id'} component={SubmitFeedbackForm} />
          <Route exact path={path + '/AllFeedback'} component={AllFeedback} />
        </Switch>
      ],
    },
    FeedbackReport: {
      routers: [
        <Switch>
          <Route exact path={path + '/FeedbackReport'} component={FeedbackReport} />
          <Route exact path={path + '/ViewFeedback/:id'} component={ViewFeedback} />
        </Switch>
      ],
    },
    NewClaim: {
      routers: [
        <Switch>
          <Route exact path={path + '/NewClaim'} component={NewClaim} />
        </Switch>
      ],
    },
    AllClaim: {
      routers: [
        <Switch>
          <Route exact path={path + '/AllClaim'} component={AllClaim} />
          <Route exact path={path + '/ViewClaim/:id'} component={ViewClaim} />
        </Switch>
      ],
    },
    NewProgress: {
      routers: [
        <Switch>
          <Route exact path={path + '/NewProgress'} component={NewDPR} />
        </Switch>
      ],
    },
    MonthlyReport: {
      routers: [
        <Switch>
          <Route exact path={path + '/MonthlyReport'} component={ProgressReport} />
          <Route exact path={path + '/ViewProgress/:id'} component={NewDPR} />
        </Switch>
      ],
    },
  };

  
}

export default getRoutes;
